import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  form: {
    title: "",
    description: "",
    url: "",
    thumbnail: "",
    categoryId: "",
    networkId: "",
  },
  isDeleteModalOpen: false,
  selectedVideoId: null,
  isPreviewModalOpen: false,
  previewUrl: "",
  selectedVideo: null,
  isEditModalOpen: false,
  editVideoData: null,
  searchTerm: "",
  byKey: {},
};

const videoSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    setFullForm: (state,action) => {
      state.form = { ...state.form,...action.payload };
    },
    setFormField: (state,action) => {
      const { field,value } = action.payload;
      state.form[field] = value;
    },
    resetForm: (state) => {
      state.form = initialState.form;
    },
    setSearchTerm: (state,action) => {
      state.searchTerm = action.payload;
    },
    openDeleteModal: (state,action) => {
      state.isDeleteModalOpen = true;
      state.selectedVideoId = action.payload;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.selectedVideoId = null;
    },
    openPreviewModal: (state,action) => {
      state.isPreviewModalOpen = true;
      state.previewUrl = action.payload.url;
      state.selectedVideo = action.payload;
    },
    closePreviewModal: (state) => {
      state.isPreviewModalOpen = false;
      state.previewUrl = "";
      state.selectedVideo = null;
    },
    openEditModal: (state,action) => {
      state.isEditModalOpen = true;
      const video = action.payload;
      console.log("openEditModal",video)
      state.editVideoData = {
        id: video.id,
        title: video.title || "",
        description: video.description || "",
        thumbnail: video.thumbnail || "",
        categoryId: video.categories?.[0]?.id || "",
        networks: video.networks ? video.networks.map(n => ({ id: n.id,name: n.name })) : [],
        networkIds: video.networks ? video.networks.map(n => n.id) : [],
      };
    },
    closeEditModal: (state) => {
      state.isEditModalOpen = false;
      state.editVideoData = null;
    },
    updateEditField: (state,action) => {
      const { field,value } = action.payload;
      if (state.editVideoData) {
        state.editVideoData[field] = value;
      }
    },
    setVideosByKey: (state,action) => {
      const { key,videos,title,playlists } = action.payload;
      state.byKey[key] = {
        title: title,
        video: videos,
        playlist: playlists
      }
    },
    clearVideosByKey: (state,action) => {
      const { key } = action.payload;
      delete state.byKey[key];
    },
    clearAllVideos: (state) => {
      state.byKey = {};
    },
  },
});

export const {
  setFullForm,
  setFormField,
  resetForm,
  setSearchTerm,
  openDeleteModal,
  closeDeleteModal,
  openPreviewModal,
  closePreviewModal,
  openEditModal,
  closeEditModal,
  updateEditField,
  setVideosByKey,clearVideosByKey,clearAllVideos
} = videoSlice.actions;

export default videoSlice.reducer;
